export default __webpack_public_path__ + "static/media/allocation_play.992a57ed.svg";